function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
define('module/Video-Manager',[],function () {
  'use strict';

  /**
   * CORTEX Video Manager
   * -----------------------
   * 
   * Creates video iFrames and manages 
   * the terminating of playing videos, 
   * when others become played.
   * 
   * Supports:
   * - YouTube videos
   * - Vimeo videos
   * 
   * @example 
   *   HTML:
   *      <div class="cortex-video" data-id="ABC123" data-hoster="youtube"></div>
   *      <div class="cortex-video" data-id="DEF456" data-hoster="vimeo"></div>
   *   JS:
   *      let oCortexVideoManager = new CortexVideoManager('cortex-video' [, oOpts]);
   * 
   * @author Michael Bindig <mbi@sopg.de>
   * @author Kai Schoenhoff <ks@sopg.de>
   * @copyright (c) 2024, SOPG GbR
   * @jira CHEF-101
   * @jira CHEF-346
   * 
   * @created 2017-10-26
   * @updated 2021-01-20
   * 
   * @type CortexVideoManager
   */
  var CortexVideoManager = /*#__PURE__*/function () {
    /**
     * Constructor.
     * 
     * @author Michael Bindig <mbi@sopg.de>
     * 
     * @created 2017-10-26
     * @updated 2020-03-10
     * 
     * @returns {CortexVideoManager}
     */
    function CortexVideoManager() {
      _classCallCheck(this, CortexVideoManager);
      /**
       * Selectors.
       * @type Object
       */
      this.oSel = {
        videoItem: '.embedded-video',
        videoContainer: '.video-container__inner'
      };

      /**
       * Settings.
       * @type Object
       */
      this.oSet = {
        /* API script URLs */
        script: {
          youtubeIframeApi: 'https://www.youtube.com/iframe_api',
          vimeoApi: 'https://player.vimeo.com/api/player.js'
        },
        opts: {
          /* Controls, whether videos will be 
          immediately initialized, as soon as 
          the API has been loaded. */
          instantInit: true,
          /* Stop method for video players 
          can be "pause" or "stop". */
          stopMethod: 'pause',
          /* Defines the CSS ID prefixes, 
          when CSS IDs have to be created. */
          cssIdPrefix: {
            youtube: 'youtubeVideo',
            vimeo: 'vimeoVideo'
          },
          youtubeIframeApi: {
            height: 360,
            width: 640,
            origin: window.location.origin || window.location.protocol + '//' + window.location.host,
            playerVars: {
              autoplay: 0,
              color: 'white'
            }
          },
          vimeoApi: {
            loop: false,
            width: 640,
            color: '08508a',
            title: false,
            autoplay: 0
          },
          onPlay: function onPlay($video) {},
          onReady: function onReady(aYoutubeVideos, aVimeoVideos) {},
          onStop: function onStop($video) {}
        }
      };

      /**
       * Vimeo video player instance.
       * @type type
       */
      this.VimeoPlayer = null;

      /**
       * jQuery collection of all found videos, 
       * based on the constructor's video CSS selector.
       * @type $
       */
      this.$videos = null;

      /**
       * YouTube video items.
       * @type Array
       */
      this.aYoutubeVideos = [];

      /**
       * Vimeo video items.
       * @type Array
       */
      this.aVimeoVideos = [];

      /**
       * @created 2020-03-10
       * @jira CHEF-187
       * 
       * @type {bool}
       */
      this.bYoutubeAPILoaded = false;

      /**
       * Loaded Youtube videos.
       * 
       * @created 2020-03-10
       * @jira CHEF-187
       * 
       * @type {array}
       */
      this.aLoadedYoutubeVideos = [];

      /**
       * Loaded Vimeo videos.
       * 
       * @created 2020-03-10
       * @jira CHEF-187
       * 
       * @type {array}
       */
      this.aLoadedVimeoVideos = [];

      /**
       * All added video item CSS IDs.
       * @type Array
       */
      this.aCssIds = [];
      this.initialize();
    }

    /**
     * Initializes the video manager.
     * 
     * @author Michael Bindig <mbi@sopg.de>
     * 
     * @created 2017-10-26
     * @updated 2020-03-10
     * 
     * @returns {undefined}
     */
    return _createClass(CortexVideoManager, [{
      key: "initialize",
      value: function initialize() {
        var _this = this;
        /*
         * Register the Borlabs listener before checking the existing DOM.
         * This is the only mechanism that reacts to content inserted by the
         * Borlabs Content Blocker. A MutationObserver must not initialize the
         * YouTube player while Borlabs is still embedding the stored HTML.
         */
        this.initBorlabsContentBlockerEvents();

        /*
         * Covers videos that were already unblocked before the application
         * started, for example because consent was saved previously. The
         * zero-delay timer lets an already running Borlabs unblock operation
         * finish before the video element can be replaced by YT.Player.
         */
        window.setTimeout(function () {
          _this.initVideosAndApis($(_this.oSel.videoContainer).find(_this.oSel.videoItem));
        }, 0);
      }

      /**
       * Initializes the Borlabs Cookie content-unblock listener.
       *
       * Borlabs dispatches this event after the blocked HTML has been restored.
       * The actual player initialization is additionally moved to the next task
       * so it cannot modify the DOM from inside Borlabs' own unblock call stack.
       *
       * @returns {undefined}
       */
    }, {
      key: "initBorlabsContentBlockerEvents",
      value: function initBorlabsContentBlockerEvents() {
        var self = this;
        var sContentBlockerId = $('body').data('borlabs-youtube-content-blocker-id') || 'youtube-content-blocker';
        var fnInitializeUnblockedVideos = function fnInitializeUnblockedVideos() {
          /*
           * Always leave the current Borlabs call stack first. YT.Player
           * replaces the source element and must not do so while Borlabs is
           * still inserting or selecting that element.
           */
          window.setTimeout(function () {
            self.initVideosAndApis($(self.oSel.videoContainer).find(self.oSel.videoItem));
          }, 0);
        };

        /*
         * Fast path for the configured Online-Training Content Blocker.
         */
        window.addEventListener('borlabs-cookie-content-unblocked[' + sContentBlockerId + ']', fnInitializeUnblockedVideos);

        /*
         * Fallback for a language-specific YouTube Content Blocker that was
         * detected by its URL and therefore may use another ID. initVideo()
         * is idempotent, so receiving both events is harmless.
         */
        window.addEventListener('borlabs-cookie-handle-unblock', fnInitializeUnblockedVideos);
      }

      /**
       * Initializes video items and the required hoster APIs.
       *
       * @param {$} $videos
       * @returns {undefined}
       */
    }, {
      key: "initVideosAndApis",
      value: function initVideosAndApis($videos) {
        var bHasYoutubeVideo = false;
        var bHasVimeoVideo = false;
        this.initVideo($videos);
        $videos.each(function (iIndex, oVideo) {
          var sHoster = String($(oVideo).data('hoster') || '').toLowerCase();
          if ('youtube' === sHoster) {
            bHasYoutubeVideo = true;
          }
          if ('vimeo' === sHoster) {
            bHasVimeoVideo = true;
          }
        });
        if (bHasYoutubeVideo) {
          this.initYoutubeApi();
        }
        if (bHasVimeoVideo) {
          this.initVimeoApi();
        }
      }

      /**
       * Initializes the videos.
       * 
       * @author Lennart Bergmann <lb@sopg.de>
       * @jira CHEF-187
       * 
       * @created 2020-03-10
       * 
       * @returns {undefined}
       */
    }, {
      key: "initVideo",
      value: function initVideo($videos) {
        var self = this;
        $videos.each(function () {
          var $video = $(this);
          if (true === $video.data('video-manager-initialized')) {
            return;
          }
          var sId = String($video.data('id') || '');
          var sHoster = String($video.data('hoster') || '').toLowerCase();
          var sLang = String($video.data('lang') || '');
          if ('' === sId || -1 === $.inArray(sHoster, ['youtube', 'vimeo'])) {
            return;
          }
          $video.data('video-manager-initialized', true);
          var oVideoObj = {
            video: $video,
            id: sId,
            player: null,
            lang: sLang
          };
          if ('youtube' === sHoster) {
            self.aYoutubeVideos.push(oVideoObj);
          }
          if ('vimeo' === sHoster) {
            self.aVimeoVideos.push(oVideoObj);
          }
        });
      }

      /**
       * Initializes the YouTube iFrame API, 
       * by adding CSS IDs to each of the YouTube
       * video items (if it has no CSS ID), 
       * loading the YouTube API script asyncronously 
       * and calling the createYoutubePlayers() method, 
       * when the API has been loaded.
       * 
       * @author Michael Bindig <mbi@sopg.de>
       * 
       * @created 2017-11-23
       * @updated 2020-03-10
       * 
       * @returns {CortexVideoManager}
       */
    }, {
      key: "initYoutubeApi",
      value: function initYoutubeApi() {
        if (0 === this.aYoutubeVideos.length) {
          return;
        }
        var self = this;
        if ('undefined' !== typeof window.YT && 'function' === typeof window.YT.Player) {
          this.bYoutubeAPILoaded = true;
          this.createYoutubePlayers();
          return this;
        }

        /* Load the YouTube iFrame API script asynchronously only once. */
        if (false === this.bYoutubeAPILoaded) {
          var fnPreviousYoutubeReady = window.onYouTubeIframeAPIReady;
          window.onYouTubeIframeAPIReady = function () {
            if ('function' === typeof fnPreviousYoutubeReady) {
              fnPreviousYoutubeReady();
            }
            self.createYoutubePlayers();
          };
          this.bYoutubeAPILoaded = true;
          this.loadAsyncScript(this.oSet.script.youtubeIframeApi);
        } else {
          self.createYoutubePlayers();
        }
        return this;
      }

      /**
       * Initializes the Vimeo API, 
       * by adding CSS IDs to each of the Vimeo
       * video items (if it has no CSS ID), 
       * loading the Vimeo API using requireJS,
       * setting the Vimeo Player and calling the 
       * createVimeoPlayers() method, 
       * when the API has been loaded.
       * 
       * @author Michael Bindig <mbi@sopg.de>
       * 
       * @created 2017-11-23
       * @updated 2020-03-10
       * 
       * @returns {CortexVideoManager}
       */
    }, {
      key: "initVimeoApi",
      value: function initVimeoApi() {
        if (0 === this.aVimeoVideos.length) {
          return;
        }
        var self = this;

        /* Require the Vimeo 
        API player script. */
        require([self.oSet.script.vimeoApi], function (fnVimeoPlayer) {
          /* Set the Vimeo video player. */
          self.VimeoPlayer = fnVimeoPlayer;
          self.createVimeoPlayers();
        });
        return this;
      }

      /**
       * Creates the YouTube iFrames (players), 
       * using the YouTube iFrame API. If "instantInit" 
       * setting is set to FALSE, the YouTube iFrame 
       * creation will just be prepared, so that it can 
       * be done later on by triggering "init" on 
       * the corresponding DOM video item.
       * 
       * @author Michael Bindig <mbi@sopg.de>
       * 
       * @created 2017-11-23
       * @updated 2020-03-10
       * 
       * @returns {undefined}
       */
    }, {
      key: "createYoutubePlayers",
      value: function createYoutubePlayers() {
        var _this2 = this;
        if ('undefined' === typeof YT || 'function' !== typeof YT.Player) {
          return;
        }
        var self = this;
        var _loop = function _loop() {
          var oItem = _this2.aYoutubeVideos[iCnt];

          /* Check if this video was already loaded. */
          if (-1 !== $.inArray(oItem, _this2.aLoadedYoutubeVideos)) {
            return 1; // continue
          }

          /* Add a CSS ID to the video, if 
          it has none or an already used one. */
          if (!oItem.video[0].hasAttribute('id') || '' === oItem.video.attr('id') || -1 < $.inArray(oItem.video.attr('id'), _this2.aCssIds)) {
            oItem.video.attr('id', _this2.oSet.opts.cssIdPrefix.youtube + iCnt);
          }

          /* Backup the CSS ID, 
          to ensure that it is unique. */
          _this2.aCssIds.push(oItem.video.attr('id'));
          var oSettings = $.extend(true, {}, _this2.oSet.opts.youtubeIframeApi, {
            videoId: oItem.id,
            events: {
              onStateChange: self.onYoutubePlayerStateChange.bind(self)
            },
            playerVars: {
              cc_load_policy: 'en' === oItem.lang ? 1 : 0
            }
          });

          /* Bind the init event, 
          that initializes the video player. */
          oItem.video.one('init', function () {
            oItem.player = new YT.Player(oItem.video.attr('id'), oSettings);
          });

          /* Initialize video player, 
          if "instantInit" option is TRUE. */
          if (_this2.oSet.opts.instantInit) {
            oItem.video.trigger('init');
          }
          _this2.aLoadedYoutubeVideos.push(oItem);
        };
        for (var iCnt = 0; iCnt < this.aYoutubeVideos.length; iCnt++) {
          if (_loop()) continue;
        }
      }

      /**
       * Creates the Vimeo iFrames (players), 
       * using the Vimeo API. If "instantInit" 
       * setting is set to FALSE, the Vimeo iFrame 
       * creation will just be prepared, so that it can 
       * be done later on by triggering "init" on 
       * the corresponding DOM video item.
       * 
       * @author Michael Bindig <mbi@sopg.de>
       * 
       * @created 2017-11-23
       * @updated 2020-03-10
       * 
       * @returns {undefined}
       */
    }, {
      key: "createVimeoPlayers",
      value: function createVimeoPlayers() {
        var _this3 = this;
        if ('function' !== typeof this.VimeoPlayer) {
          return;
        }
        var self = this;
        var _loop2 = function _loop2() {
          var oItem = _this3.aVimeoVideos[iCnt];
          if (-1 !== $.inArray(oItem, _this3.aLoadedVimeoVideos)) {
            return 1; // continue
          }

          /* Add a CSS ID to the video, if 
          it has none or an already used one. */
          if (!oItem.video[0].hasAttribute('id') || '' === oItem.video.attr('id') || -1 < $.inArray(oItem.video.attr('id'), self.aCssIds)) {
            oItem.video.attr('id', self.oSet.opts.cssIdPrefix.vimeo + iCnt);
          }

          /* Backup the CSS ID, 
          to ensure that it is unique. */
          self.aCssIds.push(oItem.video.attr('id'));
          var sCssId = oItem.video.attr('id');
          var oSettings = $.extend({}, _this3.oSet.opts.vimeoApi, {
            id: oItem.id
          });

          /* Bind the init event, 
          that initializes the video player. */
          oItem.video.one('init', function () {
            oItem.player = new self.VimeoPlayer(oItem.video.attr('id'), oSettings);
            oItem.player.on('play', self.onVimeoPlayerPlay.bind(self, sCssId));
          });

          /* Initialize video player, 
          if "instantInit" option is TRUE. */
          if (_this3.oSet.opts.instantInit) {
            oItem.video.trigger('init');
          }
          _this3.aLoadedVimeoVideos.push(oItem);
        };
        for (var iCnt = 0; iCnt < this.aVimeoVideos.length; iCnt++) {
          if (_loop2()) continue;
        }
      }

      /**
       * Callback function for 
       * YouTube player state changes.
       * 
       * @author Michael Bindig <mbi@sopg.de>
       * @author Kai Schoenhoff <ks@sopg.de>
       * 
       * @created 2017-11-23
       * @updated 2024-12-20
       * 
       * @param {Object} oEvent
       * @returns {undefined}
       */
    }, {
      key: "onYoutubePlayerStateChange",
      value: function onYoutubePlayerStateChange(oEvent) {
        if (oEvent.data === YT.PlayerState.PLAYING) {
          var $video = $(oEvent.target.getIframe());
          this.stopVimeoPlayers();
          this.stopYoutubePlayers($video.attr('id'));
          this.oSet.opts.onPlay($video);
        }
      }

      /**
       * Callback function for the
       * Vimeo player's play event.
       * 
       * @author Michael Bindig <mbi@sopg.de>
       * 
       * Created: 2017-11-23
       * Updated: 2017-11-24
       * 
       * @param {String} sCssId The currently played video's CSS ID
       * @returns {undefined}
       */
    }, {
      key: "onVimeoPlayerPlay",
      value: function onVimeoPlayerPlay(sCssId) {
        var $video = $('#' + sCssId);
        this.stopYoutubePlayers();
        this.stopVimeoPlayers(sCssId);
        this.oSet.opts.onPlay($video);
      }

      /**
       * Stops all previously initialized YouTube players, 
       * based on the "stopMethod" from the settings.
       * If sExceptCssId is given, the YouTube player,
       * having this CSS ID won't be stopped.
       * 
       * @author Michael Bindig <mbi@sopg.de>
       * 
       * Created: 2017-11-23
       * Updated: 2017-11-24
       * 
       * @param {String} sExceptCssId (optional) YouTube player CSS ID to exclude
       * @returns {undefined}
       */
    }, {
      key: "stopYoutubePlayers",
      value: function stopYoutubePlayers(sExceptCssId) {
        var self = this;
        $.each(self.aYoutubeVideos, function (iCnt) {
          var oItem = self.aYoutubeVideos[iCnt];
          if ('undefined' === typeof sExceptCssId || sExceptCssId !== oItem.video.attr('id')) {
            switch (self.oSet.opts.stopMethod) {
              case 'stop':
                if (null !== oItem.player) {
                  oItem.player.stopVideo();
                  self.oSet.opts.onStop(oItem.video);
                }
                break;
              case 'pause':
                if (null !== oItem.player) {
                  oItem.player.pauseVideo();
                  self.oSet.opts.onStop(oItem.video);
                }
                break;
            }
          }
        });
      }

      /**
       * Stops all previously initialized Vimeo players, 
       * based on the "stopMethod" from the settings.
       * If sExceptCssId is given, the YouTube player,
       * having this CSS ID won't be stopped.
       * 
       * @author Michael Bindig <mbi@sopg.de>
       * 
       * Created: 2017-11-23
       * Updated: 2017-11-24
       * 
       * @param {String} sExceptCssId (optional) YouTube player CSS ID to exclude
       * @returns {undefined}
       */
    }, {
      key: "stopVimeoPlayers",
      value: function stopVimeoPlayers(sExceptCssId) {
        var self = this;
        $.each(self.aVimeoVideos, function (iCnt) {
          var oItem = self.aVimeoVideos[iCnt];
          if ('undefined' === typeof sExceptCssId || sExceptCssId !== oItem.video.attr('id')) {
            switch (self.oSet.opts.stopMethod) {
              case 'stop':
                if (null !== oItem.player) {
                  oItem.player.unload();
                  self.oSet.opts.onStop(oItem.video);
                }
                break;
              case 'pause':
                if (null !== oItem.player) {
                  oItem.player.pause();
                  self.oSet.opts.onStop(oItem.video);
                }
                break;
            }
          }
        });
      }

      /**
       * Loads a script, having the given
       * URL asynchronously into the DOM.
       * 
       * @author Michael Bindig <mbi@sopg.de>
       * 
       * Created: 2017-11-23
       * Updated: 2017-11-24
       * 
       * @param {String} sSrc
       * @returns {Element}
       */
    }, {
      key: "loadAsyncScript",
      value: function loadAsyncScript(sSrc) {
        var oTag = document.createElement('script');
        var oFirstScriptTag = document.getElementsByTagName('script')[0];
        oTag.src = sSrc;
        oTag.async = true;
        oFirstScriptTag.parentNode.insertBefore(oTag, oFirstScriptTag);
        return oTag;
      }

      /**
       * Sets the video thumbnails.
       * 
       * @author Lennart Bergmann <lb@sopg.de>
       * @jira CHEF-187
       * 
       * @created 2020-03-10
       * 
       * @param {String} sSrc
       * @returns {Element}
       */
    }, {
      key: "setThumbnails",
      value: function setThumbnails() {
        /*
         * Thumbnails are rendered as local image URLs by PHP. No additional
         * request to a WordPress cache directory is required.
         */
        return this;
      }
    }]);
  }();
  return CortexVideoManager;
});

